import React from "react";
import Routes from "./Routes";
import LiquidEther from "./components/LiquidEther";
import Footer from "./components/ui/Footer";

function App() {
  return (
    <div className="min-h-screen relative">
      {/* Global Liquid Ether Background */}
      <div className="fixed inset-0 z-0">
        <LiquidEther
          colors={["#1e3a8a", "#3b82f6", "#60a5fa", "#93c5fd"]}
          mouseForce={25}
          cursorSize={120}
          autoDemo={true}
          autoSpeed={0.3}
          autoIntensity={1.8}
          resolution={0.6}
          className="w-full h-full"
        />
      </div>

      {/* App Content */}
      <div className="relative z-10 glass-theme min-h-screen flex flex-col">
        <div className="flex-1">
          <Routes />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
